<div class="dialog">
  <div class="dialog-top">
    <h4 class="dialog-title">{{ data.title }}</h4>
  </div>
  <mat-dialog-content class="dialog-flex">
    @if (data.message) {
      <p class="confirm-message">{{ data.message }}</p>
    }
    @if (data.detail) {
      <p class="confirm-detail">{{ data.detail }}</p>
    }
    <div class="dialog-box-s">
      <mat-dialog-actions class="button-group">
        <app-button typeBtn="secondary" color="grey" textColor="white"
          [message]="data.cancelLabel" (click)="cancel()"></app-button>
        <app-button typeBtn="primary"
          [color]="data.dangerous ? 'red' : 'var(--primary-color)'"
          textColor="white"
          [message]="data.confirmLabel" (click)="confirm()"></app-button>
      </mat-dialog-actions>
    </div>
  </mat-dialog-content>
</div>
